import React, { useState, useMemo } from "react";
import "./CommentsTree.css";

function getTree(list) {
  if (!list) {
    return [];
  }
  const roots = [];
  const childrenByParentId = {};

  list.forEach((item) => {
    if (!item.parentId) {
      roots.push(item);
      return;
    }
    if (!childrenByParentId[item.parentId]) {
      childrenByParentId[item.parentId] = [];
    }

    childrenByParentId[item.parentId].push(item);
  });
  function buildNodes(nodes) {
    if (!nodes) {
      return null;
    }
    return nodes.map((node) => ({
      ...node,
      children: buildNodes(childrenByParentId[node.id]),
    }));
  }

  return buildNodes(roots);
}

export default function CommentsTree({ comments, sendComment }) {
  const [comment, setComment] = useState("");
  const tree = useMemo(() => {
    return getTree(comments);
  }, [comments]);
  const [activeCommentBox, setActiveCommentBox] = useState(null);

  if (!comments) {
    return <p>Carregando...</p>;
  }

  function renderItem(item) {
    return (
      <li key={item.id} className="promotion-modal-comments-tree__item">
        <img
          className="promotion-modal-comments-tree__item__avatar"
          src={item.user.avatarUrl}
          alt={`Foto de ${item.user.name}`}
        />
        <div className="promotion-modal-comments-tree_info">
          <span className="promotion-modal-comments-tree__item__name">
            {item.user.name}
          </span>
          <p>{item.comment}</p>
          <button
            type="button"
            className="promotion-modal-comments-tree__answer-button"
            onClick={() => {
              setComment("");
              setActiveCommentBox(
                activeCommentBox === item.id ? null : item.id
              );
            }}
          >
            Responder
          </button>
          {activeCommentBox === item.id && (
            <div className="promotion-modal-comments-tree__comment-box">
              <textarea
                value={comment}
                onChange={(event) => {
                  setComment(event.target.value);
                }}
              ></textarea>
              <button
                className="promotion-modal-comments-tree__send-button"
                type="button"
                onClick={() => {
                  sendComment(comment, item.id);
                  setComment("");
                  setActiveCommentBox(null);
                }}
              >
                Enviar
              </button>
            </div>
          )}
          {item.children && renderList(item.children)}
        </div>
      </li>
    );
  }

  function renderList(list) {
    return (
      <ul className="promotion-modal-comments-tree">
        {list.map((item) => renderItem(item))}
      </ul>
    );
  }

  return renderList(tree);
}

CommentsTree.defaultProps = {
  sendComment: () => {},
};
